module.exports = __webpack_public_path__ + "img/n-home.44d00408.svg";